// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"590":"0d22a6d3","678":"62288594","929":"b6f651d8"}[chunkId] + ".chunk.css";
};